<template>
  <div>
    <component
      :is="component"
    />
  </div>
</template>
<script>
import Func3CartaoVirtual from '@/views/3/Func3CartaoVirtual.vue'

export default {
  name: 'Func3',
  data () {
    return {
      component: Func3CartaoVirtual
    }
  }
}
</script>
